require('./bootstrap');

require("@iconfu/svg-inject/dist/svg-inject.min.js");
require("slick-carousel/slick/slick.min.js");
require("jquery-ui/ui/widgets/sortable");

